import React, { ReactElement, useEffect } from 'react';
import { useDataCollection, DataCollectionValues } from '../../../../hooks';
import CheckCard from '../../../components/Form/CheckCard';
import { InjectedWizardStepProps } from '../../../components/Steps/WizardStep';
import StepHeader from '../../../components/Layout/StepHeader';
import { houseGlazingOptions } from '../../../../data/enumerations';
import { Form } from 'formik';

const StepHouseGlazing = ({ completeStep }: InjectedWizardStepProps): ReactElement<'div'> | null => {
    const { handleChange, values } = useDataCollection();

    useEffect(() => {
        if (values.glazing) {
            completeStep && completeStep(true);
        }
    }, [values, completeStep]);

    return (
        <Form>
            <StepHeader title="Jak velké máte prosklení domu?" />
            <div className={'wiz-card wiz-card--small'}>
                <div className={'wiz-card__inner'}>
                    {houseGlazingOptions.map((option) => {
                        return (
                            <div key={option.value} className={'wiz-card-item'}>
                                <CheckCard
                                    name={'glazing'}
                                    onChange={handleChange}
                                    checked={values.glazing === option.value}
                                    value={option.value}
                                >
                                    <div className={'check-card__inner'}>
                                        <div className={'check-card__image'}>
                                            <img src={option.img} alt="" />
                                        </div>
                                        <div className="check-card__text">
                                            <h3>{option.title}</h3>
                                            <p>{option.description}</p>
                                        </div>
                                    </div>
                                </CheckCard>
                            </div>
                        );
                    })}
                </div>
            </div>
        </Form>
    );
};

export default StepHouseGlazing;
